import OperatorGetParamsOperatorOpenApiModel = OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel;
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import StringHelper from "~/ts/library/StringHelper";

export default function getOperatorStatusDescr(operator: OperatorGetParamsOperatorOpenApiModel) {
    let customOperatorStatus = OperatorAccountStore.customStatusDictionary.value[operator.customStatusId];
    if (customOperatorStatus) {
        return customOperatorStatus.descr;
    }
    if (!operator.statusId) {
        return "Offline";
    }
    let result = OperatorAccountStore.statusList.value
        .find(item => item.statusId === operator.statusId)
        ?.descr;
    if (result) {
        result = StringHelper.capitalize(result);
    }
    return result;
}